<template>
  <div class="shell">
    <div class="">
      <div class="nav">
        <app-nav />
      </div>

      <infinite-scroll @load="pageend" class="main pb-12">
        <slot></slot>
      </infinite-scroll>

      <portal-target name="overlay"></portal-target>
      <portal-target name="modal"></portal-target>
    </div>
  </div>
</template>

<script>
 import {mapState, mapGetters} from 'vuex';

 import AppNav from '@/components/AppNav';
 import SpellBar from '@/components/SpellBar';
 import NoteSelect from '@/components/NoteSelect';
 import InfiniteScroll from '@/components/InfiniteScroll';

 export default {
   name: 'shell',

   components: {AppNav, SpellBar, NoteSelect, InfiniteScroll},

   computed: {
     ...mapState({
       lastRoute: state => state.lastRoute
     }),


     ...mapGetters(['isPaidCustomer']),

     pageName () {
       return this.$route.name;
     }
   },

   methods: {
     pageend (i, done = () => {}) {
       this.$emit('pageend', done);
     }
   }
 }
</script>


<style scoped>
 

 .overlay {
   background: rgba(0,0,0, .65);
   z-index: 4;
 }

 .nav {
   display: block;
 }

</style>
